import actions from "./actions";

export default {
  namespaced: true,
  state: {
    dataLoading: false,
    auMyStackingOrders: null
  },
  getters: {
    dataLoading: state => {
      return state.dataLoading;
    },
    myStackingOrders: state => {
      return state.auMyStackingOrders;
    }
  },
  mutations: {
    setDataLoading(state, dataLoading) {
      state.dataLoading = dataLoading;
    },
    setMyStackingOrders(state, orders) {
      state.auMyStackingOrders = orders;
    }
  },
  actions
};